<template>
  <div class="flex flex-col gap-2" v-if="offlinePools.length > 0">
    <div class="text-gray-200 text-sm">
      {{ $t("BleUnavailablePoolsTitle") }}
    </div>
    <OfflinePoolCard
      :pool="pool"
      v-for="pool in offlinePools"
      :key="pool.deviceId"
    />
  </div>
</template>

<script setup lang="ts">
import OfflinePoolCard from "@/features/ble/public/OfflinePoolCard.vue";
import { useStoredBlePools } from "@/features/ble/utils/localStorage.ts";
import { computed } from "vue";

const props = defineProps<{ excludedDeviceIds: string[] }>();

const storedPools = useStoredBlePools();

const offlinePools = computed(() =>
  storedPools.value.filter(
    (storedPool) =>
      !props.excludedDeviceIds.some(
        (deviceId) => deviceId === storedPool.deviceId
      )
  )
);
</script>
